import { vrfAbi } from '@/abi'
import { useContractAddresses } from '@/hooks'
import { useReadContract } from 'wagmi'

export const useLastSubscriptionId = () => {
  const contracts = useContractAddresses()

  const { data, isLoading, refetch } = useReadContract({
    abi: vrfAbi,
    address: contracts.vrf,
    functionName: 'getCurrentSubId',
  })

  const lastSubscriptionId = data ? Number(data) : null

  return { data: lastSubscriptionId, isLoading, refetch }
}
